// @ts-nocheck

import React, { useContext, lazy, Suspense, useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import { ScrollingGuideContext } from 'contexts/ScrollingGuide'
import AppConfigs from 'configs/env'
import { useSelector } from 'react-redux'
import { getIsAeonSelector, getIsCompletedSelector, getIsOfflineSelector } from 'redux/home/selectors'
import GuidePage from 'pages/guide'
import NoticeGuide from './components/NoticeGuide'

const HomePageView = (props) => {
  const { isErrorPhoneNumber, hasJoinedToothlens } = props
  const { toggleShowTips } = useContext(ScrollingGuideContext)
  const isCompleted = useSelector((state) => getIsCompletedSelector(state))
  const isOffline = useSelector((state) => getIsOfflineSelector(state))
  const isAeon = useSelector((state) => getIsAeonSelector(state))
  useEffect(() => {
    if(isCompleted) {
      document.getElementById('thankyou')?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [isCompleted])
  return (
    <div className="container">
      {hasJoinedToothlens && (
        <>
          {isCompleted ? (
            <div className="thankyou-container" id="thankyou">
              <img className="img-full" src="assets/img/thankyou.png" alt="thank-you" />
            </div>
          ) : (
            <InView threshold={0.9} onChange={(inView) => toggleShowTips(!inView)}>
              <section className="register-warp" id="joinNow">
                <h2 className="name-block">
                  <span className="border-line"></span>
                  <span className="text">
                    ĐIỀN THÔNG TIN <br />
                    NHẬN BÁO CÁO
                  </span>
                  <span className="border-line"></span>
                </h2>
                <div className="container">
                  <div className={`register ${props.isDisableInput == true && 'isDisableInput'}`}>
                    <form className="register-form" onSubmit={props.handleSubmit}>
                      <div className="form-group">
                        <label className="title-form" htmlFor="usr">
                          Họ và tên <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="usr"
                          name="fullName"
                          placeholder="Nhập họ và tên..."
                          maxLength={50}
                          min="0"
                          max="50"
                          {...props.register('fullName', {
                            onChange: (elm) => {
                              props.setValue(
                                'fullName',
                                elm.target.value.replace(
                                  /[^A-Za-zàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆìÌỉỈĩĨíÍịỊòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰỳỲỷỶỹỸýÝỵỴđĐ\s]*/g,
                                  ''
                                )
                              )
                            },
                            onBlur: (e) => props.setValue('fullName', e.target.value.trim()),
                          })}
                        />
                      </div>
                      <div className="form-group">
                        <label className="title-form" htmlFor="phoneNumber">
                          Số điện thoại <span>*</span>
                        </label>
                        <input
                          type="tel"
                          className={`form-control ${props?.isErrorPhoneNumber && 'errors'}`}
                          id="phoneNumber"
                          maxLength={10}
                          name="phoneNumber"
                          {...props.register('phoneNumber', {
                            onChange: (elm) => {
                              props.setValue('phoneNumber', elm.target.value.replace(/\D/g, ''))
                            },
                          })}
                          placeholder="Nhập số điện thoại..."
                          min="0"
                          max="10"
                          inputMode="numeric"
                        />

                        <small className={`form-placeholder ${isErrorPhoneNumber && 'errors'}`}>
                          Vui lòng nhập số điện thoại có 10 chữ số bắt đầu bằng số 0
                        </small>
                      </div>
                      <div className="group-checkbox">
                        <div className="checkbox-item">
                          <label htmlFor="isAgree">
                            <input type="checkbox" name="isAgree" id="isAgree" {...props.register('isAgree')} />
                            <span className="checkmark"></span>
                          </label>
                          <p>Tôi đồng ý nhận các thông tin bán hàng, khuyến mãi, quảng cáo, và khảo sát của Unilever.</p>
                        </div>
                      </div>
                      <div className="policy-container">
                        <p>
                          Bằng việc đăng ký, tôi xác nhận trên 16 tuổi và đã đọc thông báo về{' '}
                          <a onClick={() => window.open(AppConfigs.privacyLink, '_blank')} href="javascript:;">
                            Quyền riêng tư
                          </a>{' '}
                          và{' '}
                          <a onClick={() => window.open(AppConfigs.cookieLink, '_blank')} href="javascript:;">
                            Thông báo cookies
                          </a>{' '}
                          của Unilever để hiểu cách Unilever sử dụng thông tin của tôi.
                        </p>
                      </div>
                      <div className="btn-wrapper text-center">
                        <button type="submit" className="btn btn-primary btn-block disabled" id="btn-register">
                          NHẬN BÁO CÁO
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </InView>
          )}
        </>
      )}

      <GuidePage isAeon={isAeon} isOffline={isOffline} />
      <NoticeGuide isAeon={isAeon} isOffline={isOffline} />

      {!hasJoinedToothlens && (
        <section className="register-warp" id="joinNow">
          <div className="container pre-container">
            <div className={`register ${props.isDisableInput == true && 'isDisableInput'}`}>
              <form className="register-form" onSubmit={props.handleSubmit}>
                <div className="btn-wrapper text-center">
                  <button type="submit" className="btn btn-primary btn-block" id="btn-register">
                    THAM GIA NGAY
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      )}
    </div>
  )
}
export default HomePageView
